export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表单提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '邮箱',
  'pages.template.form.department': '部门',
  'pages.template.form.joinDate': '入职日期',
  'pages.template.form.remarks': '备注',
  'pages.template.placeholder.name': '请输入姓名',
  'pages.template.placeholder.email': '请输入邮箱',
  'pages.template.placeholder.department': '请选择部门',
  'pages.template.placeholder.remarks': '请输入备注信息',
  'pages.template.validation.nameRequired': '请输入姓名',
  'pages.template.validation.emailRequired': '请输入邮箱',
  'pages.template.validation.emailInvalid': '邮箱格式不正确',
  'pages.template.validation.departmentRequired': '请选择部门',
  'pages.template.validation.joinDateRequired': '请选择入职日期',
  'pages.template.department.tech': '技术部',
  'pages.template.department.sales': '销售部',
  'pages.template.department.hr': '人力资源部',
  'pages.template.department.finance': '财务部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
  'pages.reimbursements.dashboard.title': '工作台',
  'pages.reimbursements.dashboard.quickInvoice': '去采集发票',
  'pages.reimbursements.dashboard.quickClaim': '填写报销单',
  'pages.reimbursements.dashboard.quickAnalytics': '查看统计',
  'pages.reimbursements.invoices.title': '发票采集',
  'pages.reimbursements.claims.title': '我的报销单',
  'pages.reimbursements.claimForm.title': '填写报销单',
  'pages.reimbursements.myAnalytics.title': '我的统计',
  'pages.reimbursements.managementCockpit.title': '管理统计',
  'pages.reimbursements.financeAnalytics.title': '财务统计',
  'pages.reimbursements.specialAnalytics.title': '财务统计',
  'pages.reimbursements.anomalyRules.title': '异常规则',
  'pages.settings.title': '设置',
  'pages.settings.aliyunOcr.title': '阿里云 OCR 凭证',
  'pages.settings.aliyunOcr.description':
    '凭证留空表示沿用当前已保存值。如需更换凭证，请同时填写新的 AK 和 SK。',
  'pages.settings.aliyunOcr.accessKeyId': 'AccessKey ID',
  'pages.settings.aliyunOcr.accessKeySecret': 'AccessKey Secret',
  'pages.settings.aliyunOcr.endpoint': 'Endpoint',
  'pages.settings.aliyunOcr.endpointRequired': '请输入 Endpoint',
  'pages.settings.aliyunOcr.placeholder.accessKeyId': '请输入新的 AccessKey ID',
  'pages.settings.aliyunOcr.placeholder.accessKeySecret':
    '请输入新的 AccessKey Secret',
  'pages.settings.aliyunOcr.placeholder.endpoint': '请输入 OCR Endpoint',
  'pages.settings.aliyunOcr.configured': '已配置',
  'pages.settings.aliyunOcr.notConfigured': '未配置',
  'pages.settings.aliyunOcr.accessKeyIdStatus': 'AK 状态',
  'pages.settings.aliyunOcr.accessKeySecretStatus': 'SK 状态',
  'pages.settings.aliyunOcr.save': '保存',
  'pages.settings.aliyunOcr.refresh': '刷新',
  'pages.settings.aliyunOcr.saveSuccess': '租户 OCR 配置已保存',
  'pages.settings.workflow.title': '审批流程模板',
  'pages.settings.workflow.description':
    '这里配置当前租户提交报销单时使用的审批模板，请从审批中心返回的可选模板中选择。',
  'pages.settings.workflow.expenseClaimTemplateUuid': '报销审批流程',
  'pages.settings.workflow.expenseClaimTemplateUuidRequired':
    '请选择报销审批流程',
  'pages.settings.workflow.placeholder.expenseClaimTemplateUuid':
    '请选择报销审批流程',
  'pages.settings.workflow.save': '保存',
  'pages.settings.workflow.refresh': '刷新',
  'pages.settings.workflow.saveSuccess': '租户流程模板配置已保存',
  'pages.settings.workflow.templateMissing':
    '当前已配置模板已不可选，请重新选择可用模板。',
  'pages.settings.workflow.empty': '当前账号没有可用的审批模板',
};
